// extracted by mini-css-extract-plugin
export default {"heading":"Ot-z","corrected":"Pt-z","redirectVerbiageContainer":"Qt-z","redirectVerbiageText":"Rt-z"};